import { loadLanguageAsync } from '@/i18n'
import { helper } from '@/utils'
import config from '@/config'

export default {
  methods: {
    getTheme () {
      return this.$api.getTheme()
        .then(theme => {
          this.backgroundColor = theme.body.primary_color
          this.supportEmailAccount = theme.body.support_email_account
          this.isLoading = false
        })
        .catch((error) => {
          helper.showErrorMessage(this, this.component, error)
        })
    },
    getImageSrc () {
      let id = 'logo.png'
      let ts = Date.now()
      this.imageSrc = `${config.serverURI}/theme/${id}?${ts}`
      return this.imageSrc
    }
  },
  async created () {
    await loadLanguageAsync()
    await Promise.all([
      this.getTheme(),
      this.getImageSrc()
    ])
  },
  computed: {
    goSupportPage () {
      return `mailto:${this.supportEmailAccount}`
    }
  },
  name: 'NotFound',
  data () {
    return {
      backgroundColor: 'white',  // default color is white
      supportEmailAccount: '',
      isLoading: true,
      imageSrc: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js